<script setup lang="ts">
import type { PackageType } from '@/constants/airRoad';

import KBtn from '@/components/btns/KBtn.vue';
import KTooltip from '@/components/tooltips/KTooltip.vue';

const emit = defineEmits<{
  btnClick: [event: Event, packageType: PackageType];
}>();

function handleBtnClick(event: Event, packageType: PackageType): void {
  emit('btnClick', event, packageType);
}
</script>

<template>
  <menu
    :class="$style.newAirRoadPackAllProductsMenuList"
    data-testid="newAirRoadPackAllProductsMenuList"
  >
    <li :class="$style.li">
      <KTooltip location="top" :offset="0">
        <div :class="$style.tooltipContent">
          Pack each product in&nbsp;a&nbsp;separate carton box
        </div>
        <template #activator="{ props: tooltipProps }">
          <KBtn
            v-bind="tooltipProps"
            :class="$style.btn"
            icon="mdi-package-variant"
            size="md"
            variant="text"
            priority="info"
            @click="handleBtnClick($event, 'carton')"
          />
        </template>
      </KTooltip>
    </li>
    <li :class="$style.li">
      <KTooltip location="top" :offset="0">
        <div :class="$style.tooltipContent">
          Pack each product in&nbsp;a&nbsp;separate pallet
        </div>
        <template #activator="{ props: tooltipProps }">
          <KBtn
            v-bind="tooltipProps"
            :class="$style.btn"
            icon="mdi-shipping-pallet"
            size="md"
            variant="text"
            priority="info"
            @click="handleBtnClick($event, 'pallet')"
          />
        </template>
      </KTooltip>
    </li>
  </menu>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.newAirRoadPackAllProductsMenuList {
  line-height: 1.4;
  margin: 0;
  padding: 0;
  list-style: none;
}
  .li {
    display: inline-block;
  }
    .tooltipContent {
      max-width: 140px;
    }
    .btn {
    }
</style>
